import { render, staticRenderFns } from "./ComparacaoDeEstoques.vue?vue&type=template&id=6f3c56e6&scoped=true"
import script from "./ComparacaoDeEstoques.vue?vue&type=script&lang=js"
export * from "./ComparacaoDeEstoques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c56e6",
  null
  
)

export default component.exports